import { useQuery } from 'react-query';
import { getUserMe } from '../services/users';

export const useUserMe = () => {
  const result = useQuery('userMe', async () => await getUserMe());
  return { ...result, data: result?.data?.data };
};
